import { FC, useEffect, useState } from 'react';

import { Cookie } from 'lucide-react';

import {
    COOKIE_CONSENT_PROMPT_EVENT,
    CookieConsentService,
} from '../../services/CookieConsentService';
import { Button } from '../ui/Button';

export const CookieConsentBanner: FC = () => {
    const [visible, setVisible] = useState(() =>
        CookieConsentService.shouldRequestConsent(),
    );

    useEffect(() => {
        const showBanner = () => setVisible(true);

        window.addEventListener(COOKIE_CONSENT_PROMPT_EVENT, showBanner);

        return () => {
            window.removeEventListener(COOKIE_CONSENT_PROMPT_EVENT, showBanner);
        };
    }, []);

    if (!visible) {
        return null;
    }

    const acceptAll = () => {
        CookieConsentService.acceptAll();
        setVisible(false);
    };

    const rejectAll = () => {
        CookieConsentService.rejectAll();
        setVisible(false);
    };

    return (
        <div
            aria-label="Згода на cookies"
            className="fixed right-4 bottom-20 left-4 z-[60] mx-auto max-w-3xl rounded-xl border bg-background p-4 shadow-lg sm:right-6 sm:bottom-6 sm:left-auto sm:w-[520px]"
            data-testid="cookie-consent-banner"
            role="dialog"
        >
            <div className="flex gap-3">
                <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                    <Cookie className="h-5 w-5" aria-hidden="true" />
                </div>
                <div className="min-w-0 flex-1">
                    <h2 className="text-sm font-semibold">
                        {'Ви погоджуєтесь на використання cookies?'}
                    </h2>
                    <p className="mt-1 text-sm leading-6 text-muted-foreground">
                        {
                            'Натисніть «Прийняти всі», якщо погоджуєтесь, або «Відхилити всі», якщо ні.'
                        }{' '}
                        <a
                            className="font-medium text-foreground underline underline-offset-4 hover:text-primary"
                            href="/privacy"
                        >
                            {'Детальніше'}
                        </a>
                    </p>
                    <div className="mt-4 grid gap-2 sm:flex sm:justify-end">
                        <Button
                            onClick={rejectAll}
                            type="button"
                            variant="outline"
                        >
                            {'Відхилити всі'}
                        </Button>
                        <Button onClick={acceptAll} type="button">
                            {'Прийняти всі'}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
